import React from 'react';
import { BreadcrumbsManagerInstance } from '../../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../../shared/breadcrumbs/Breadcrumbs';
import { PsPage } from '../../../shared/components/ps-page/PsPage';
import { MessageListCard } from './MessageListCard';
import { I18nUtils } from '../../../../i18n/I18nUtils';

export class MessageListScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MESSAGES,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_MENSAJES')} breadcrumbs={breadcrumbs}>
                <MessageListCard/>
            </PsPage>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/list/MessageListScreen.jsx